/* eslint-disable mastery/no-fetch */
import { getAuthHeader } from '@app/auth/token';
import { getConnectCarrierHeaders } from '@app/client';
import { ENV_VARS } from '@env';
import { IS_PR_PREVIEW } from '@utils/constants';
import { reportCustomError } from '@utils/reportCustomError';
import { connectCarrierConfig, crossAppConfig } from '../../config';
import {
  IS_CONNECT_CARRIER_DEV_DOMAIN,
  IS_CONNECT_CARRIER_LOCAL_DEV,
  IS_CONNECT_CARRIER_LOCAL_OR_CI_CYPRESS,
} from '../harness/constants';

// ts-unused-exports:disable-next-line
export const fetchFromGraphConnectCarrierDevOnly = (kwargs: {
  body: string;
  qs?: string;
}): Promise<Response> => {
  let url =
    ENV_VARS.VITE_EXPERIMENT_ENDPOINT ??
    'https://graphql.dev.hub.mastermindtms.com';
  if (IS_CONNECT_CARRIER_LOCAL_OR_CI_CYPRESS) {
    url = crossAppConfig.apiEndpoint;
  }
  if (kwargs.qs) {
    url += `?${kwargs.qs.replace('?', '')}`;
  }
  if (
    !IS_CONNECT_CARRIER_DEV_DOMAIN &&
    !IS_CONNECT_CARRIER_LOCAL_DEV &&
    !IS_PR_PREVIEW &&
    !IS_CONNECT_CARRIER_LOCAL_OR_CI_CYPRESS
  ) {
    const err = new Error('Fetch utility used in incorrect environment.');
    reportCustomError(err);
    throw err;
  }
  return fetch(url, {
    method: 'POST',
    headers: {
      Authorization: getAuthHeader(),
      'Content-Type': 'application/json',
      'tenant-id': 'mm100-dev',
      'company-id': 'testId',
    },
    body: kwargs.body,
  });
};

type slashPath = `/${string}`;

// ts-unused-exports:disable-next-line
export const fetchFromUploadOrigin = (
  path: slashPath,
  init?: RequestInit,
): Promise<Response> => {
  return fetch(connectCarrierConfig.uploadOrigin + path, {
    method: 'POST',
    mode: 'cors',
    ...init,
    headers: {
      Authorization: getAuthHeader(),
      ...getConnectCarrierHeaders(),
      ...init?.headers,
    },
  });
};
